import imageCardCarousel from './js/image-card-list.js'
import imageGallery from './js/image-gallery.js'
import videoPlayer from './js/video.js'
import menuToggler from './js/menu.js'

import './styles/index.less'

// menu logic
const menu = document.querySelector('.region-microsite-nav')
const menuOpen = document.querySelector('.region-microsite-nav .menu-open')
const alogo = document.querySelector('#block-editorialmicrositelogo-2')

if (!menuOpen) {
  if (alogo) {
    alogo.style.display = 'block'
  }
} else {
  if (alogo) {
    alogo.style.display = 'none'
  }

  var nav = jQuery(menuOpen).closest('nav[role="navigation"]');

  menuOpen.addEventListener('click', () => {
    if (menu.classList.contains('open')) {
      menu.classList.remove('open')
      if (nav.hasClass('contextual-region')) {
        nav.css('position','');
      }
      document.body.classList.remove('modal-open')
    } else {
      menu.classList.add('open')
      jQuery(menuOpen).closest('nav[role="navigation"]').css('position','initial');
      if (nav.hasClass('contextual-region')) {
        nav.css('position','initial');
      }
      document.body.classList.add('modal-open')
    }
  })
}

// carousel logic
function removeExtraSlides() {
  if (jQuery(window).width() > 960) {
    jQuery('.field--name-field-carousel-slide').slick('slickRemove', 5)
    jQuery('.field--name-field-carousel-slide').slick('slickRemove', 4)
    jQuery('.field--name-field-carousel-slide').slick('slickRemove', 3)
  }
}

function slickInit() {
  jQuery('.field--name-field-carousel-slide').slick({
    dots: false,
    centerMode: true,
    variableWidth: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    infinite: true,
    centerPadding: '200px',
    responsive: [
      {
        breakpoint: 960,
        settings: {
          dots: false,
          centerPadding: '0',
          centerMode: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true
        }
      }
    ]
  })

  removeExtraSlides()
}
slickInit()

jQuery(window).resize(function() {
  removeExtraSlides()
})

// render image card carousel
imageCardCarousel()
jQuery(window).resize(imageCardCarousel)
imageGallery()
videoPlayer()
menuToggler()